import { CdkScrollableModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { DynamicModalContentComponent } from './dynamic-modal-content/dynamic-modal-content.component';
import { DynamicModalService } from './dynamic-modal.service';

@NgModule({
  imports: [
    CdkScrollableModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    DynamicModalContentComponent
  ],
  providers: [DynamicModalService],
  exports: []
})
export class DynamicModalModule {}
